import { createAdminResource } from 'lib/admin-kit';
import serviceNetworkSsoProviderConfig from './config';

export default createAdminResource(serviceNetworkSsoProviderConfig).Index;
